<p-toast></p-toast>
<div *ngIf="redimir" class="form-container">

    <form id="redimirVista" [formGroup]="redeemForm" (ngSubmit)="onSubmit()">
        <h2 style="text-align: center;">{{redimir.supervisor.nom_supervisor}}</h2>
        <p style="text-align: center;">{{canje(redimir.status) | uppercase }}</p>
        <div class="form-group">
            <label for="cantidad">Cantidad:</label>
            <p-inputNumber formControlName="cantidad" inputId="cantidad" [readonly]="true"
                placeholder="Ingrese la cantidad" styleClass="inputnumber" />
            <div *ngIf="redeemForm.get('cantidad')?.touched && redeemForm.get('cantidad')?.errors"
                class="error-message">
                <span *ngIf="redeemForm.get('cantidad')?.errors?.['required']">
                    La cantidad es requerida
                </span>
                <span *ngIf="redeemForm.get('cantidad')?.errors?.['min']">
                    La cantidad debe ser mayor a 0
                </span>
            </div>
        </div>

        <div class="form-group">
            <label for="fechaFinal">Fecha Final:</label>
            <input type="date" id="fechaFinal" formControlName="fechaFinal" [readonly]="true" class="form-control">
            <div *ngIf="redeemForm.get('fechaFinal')?.touched && redeemForm.get('fechaFinal')?.errors?.['required']"
                class="error-message">
                La Fecha es requerida
            </div>
        </div>

        <div class="form-group">
            <label for="observacion">Observación *:</label>
            <textarea id="observacion" formControlName="observacion" class="form-control" maxlength="255" rows="4">
      </textarea>
            <div *ngIf="redeemForm.get('observacion')?.touched && redeemForm.get('observacion')?.errors?.['required']"
                class="error-message">
                La Observación es requerida
            </div>
        </div>

        <div class="form-group file-upload">
            <label class="file-label">
                <span class="file-text">{{ archivoSeleccionado ? archivoSeleccionado.name : 'Seleccionar archivo'
                    }}</span>
                <input type="file" (change)="onFileSelected($event)" accept=".pdf,.doc,.docx,.xls,.xlsx"
                    class="file-input">
                <span class="file-button">Examinar</span>
            </label>
        </div>

        <!-- Modal de confirmación -->
        <div class="modal" *ngIf="showModal">
            <div class="modal-content">
                <h3>{{ modalTitle }}</h3>
                <p>{{ modalMessage }}</p>
                <div class="modal-buttons">
                    <button type="button" (click)="confirmarAccion()" class="btn-confirm">Confirmar</button>
                    <button type="button" (click)="cancelarAccion()" class="btn-cancel">Cancelar</button>
                </div>
            </div>
        </div>
    </form>

    <div *ngIf="redimir" class="wrapper">
        <table style="width: 100%;">
            <thead>
                <tr>
                    <td>Documento</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                <tr class="row" *ngFor="let referencia of redimir.referencias">
                    <td><a [href]="urlbase + referencia.rutaPublica + '/' + referencia.filename"
                            target="_blank">{{referencia.originalNomDocumento}}</a> </td>
                    <td><button type="button" (click)="onDestroy(referencia.id)"
                            [disabled]="redimir.referencias.length<=1" class="reject-button">
                            <i class="pi pi-trash" style="font-size: 1rem"></i>
                        </button></td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2">Documentos</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div *ngIf="redimir" class="wrapper">
        <table style="width: 100%;">
            <thead>
                <tr>
                    <td colspan="3">Casos Clinicos</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let casoclinico of redimir.casosclinicos">
                    <td>{{casoclinico.serie}}</td>
                    <td>{{casoclinico.nomHospital}}</td>
                    <td>{{casoclinico.e_puntos}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2" style="text-align: right;">Total Puntos: </td>
                    <td>{{cantidad}}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div class="button-group">
        <button type="button" (click)="onCancel()" class="cancel-button">
            Salir
        </button>

        <button type="button" (click)="onUploadDocumento()" [disabled]="!archivoSeleccionado || redimir.status!=3"
            class="submit-button">
            <i class="pi pi-plus" style="font-size: 1rem"></i> Documento
        </button>

        <button type="submit" form="redimirVista" [disabled]="!redeemForm.valid" class="submit-button">
            <i class="pi pi-plus" style="font-size: 1rem"></i> Observación
        </button>
    </div>

</div>